/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useEffect, useState } from "react";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { Dialog, CardContent, Card, Box } from "@mui/material";
import { ImageDeleteDialogPanel } from "./panels/image-delete-dialog-panel";
import { ImageDeleteDialogActions } from "./actions/image-delete-dialog-actions";

const ImageDeleteDialog = (props) => {

    const { deleteType = "REMOVE" } = props;
    const {
        openRemove,
        setOpenRemove,
        image,
        onImageDeleted,
        onImageRemoved
    } = useContext(ImageEditContext);

    const [selectedImage, setSelectedImage] = useState();
    useEffect(() => {
        setSelectedImage(image);
    }, [image]);

    const handleCancel = function () {
        setOpenRemove(false);
    };
    const handleDelete = () => {
        onImageDeleted(selectedImage);
        setOpenRemove(false);
    };
    const handleArchive = () => {
        onImageRemoved(selectedImage);
        setOpenRemove(false);
    };

    return (
        <Fragment>
            <Dialog
                open={openRemove}
                onClose={handleCancel}
                fullWidth={true}
                maxWidth='md'
                style={{ width: "50%", marginLeft: "auto", marginRight: "auto", }}
            >
                <Card
                    elevation={0}
                    style={{ width: "100%" }}
                >
                    <CardContent sx={{ flex: "1 0 auto", height: "100%" }}>
                        <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "row" }}>
                            <ImageDeleteDialogPanel
                                deleteType={deleteType}
                            />
                        </Box>
                    </CardContent>
                </Card>

                <ImageDeleteDialogActions
                    deleteType={deleteType}
                    handleCancel={handleCancel}
                    handleDelete={handleDelete}
                    handleRemove={handleArchive}
                />
            </Dialog>
        </Fragment>
    );
};

export { ImageDeleteDialog };
